module.exports = __webpack_public_path__ + "static/assets/ae564de8d4f7ca1a034180221227e91b.png";